import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { LOCATION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import {
  role_get_select
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  location_name: Yup.string()
    .required("Location Name is required")
    .min(2, "Name must be at least 2 characters"),
    location_address: Yup.string()
    .required("Location Address is required")
    .min(5,"Location must be graterthen 5 characters"),
    latitude: Yup.string()
    .required("Lantitude is required")
    .min(2, "must be at least 2 characters"),
    longitude: Yup.string()
    .required("Longiture is required")
    .min(2, "must be at least 2 characters"),
  
});
const LocationForm: React.FC<HeaderProps> = ({loadTableData,dataIn}) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues:dataIn,
    resolver: yupResolver(schema), // Attach the Yup schema to react-hook-form
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
  }, []);

  //   const onSubmit = (data: any) => {
  //     console.log("Form submitted:", data);
  //   };
  const onSubmit = (data: any) => {
    let url = LOCATION_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = data.ID;
      url =LOCATION_URLS.UPDATE;
   }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const options = [
    { value: "1", label: "Test" },
    { value: "2", label: "Test" },
    { value: "3", label: "test" },
  ];
  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 4,
      name: "location_name",
      element: {
        label: " Location Name",
        isRequired: true,
        // inputProps: { isFocussed: true },
      },
    },
  
    {
      type: "TEXT_BOX",
      width: 4,
      name: "latitude",
      element: {
        label: "Latitude",
        isRequired: true,
        // inputProps: { isFocussed: true },
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "longitude",
      element: {
        label: "Longitude",
        isRequired: true,
        // inputProps: { isFocussed: true },
      },
    },
    {
      type: "DATE",
      width: 4,
      name: "office_start_time",
      element: {
        label: "Office Start Time",
        isRequired: true,
        showTimeSelect:true,
        showTimeSelectOnly:true,
        dateFormat:"h:mm aa"
        // inputProps: { isFocussed: true },
      },
    },   
    {
      type: "DATE",
      width: 4,
      name: "office_end_time",
      element: {
        label: "Office End Time",
        isRequired: true,
         dateFormat:"h:mm aa",
        showTimeSelect:true,
        showTimeSelectOnly:true,
        // inputProps: { isFocussed: true },
      },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "location_address",
      element: {
        label: "Location Address",
        isRequired: true,
       
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",
      element: {
        label: "Submit",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default LocationForm;
